import React from 'react'
import { Script } from 'gatsby'

const Newsletter = ({ title, text }) => {
  return (
    <div className='grid sm:max-w-sm'>
      <div className='mb-3'>
        <div className='font-bold text-xl pb-2'>{title.text}</div>
        <p className='text-white opacity-90'>{text}</p>
      </div>
      <div className='w-full'>
        <form
          className='js-cm-form flex flex-col gap-y-2'
          id='subForm'
          action='https://www.createsend.com/t/subscribeerror?description='
          method='post'
          data-id='5B5E7037DA78A748374AD499497E309EE45D6B921259B6A0749C30DA8199E271747CCA3477DCC98D974EC0472F9AEEA61955B4EC06FE7BC9D191CB13BCA4056F'>
          {/* <div>
            <label htmlFor='fieldName' className='sr-only font-medium text-blue-50'>
              Name
            </label>
            <input placeholder='Name' className='w-full appearance-none rounded py-3 px-6 text-left leading-tight text-stone-800' aria-label='Name' id='fieldName' maxLength='200' name='cm-name' />
          </div> */}
          <div className='flex flex-row'>
            <label htmlFor='fieldEmail' className='sr-only font-medium text-blue-50'>
              Email
            </label>
            <input
              className='bg-transparent border border-r-0 border-white js-cm-email-input qa-input-email w-full appearance-none rounded-l py-3 px-6 text-left leading-tight text-white placeholder-stone-300'
              autoComplete='Email'
              aria-label='Email'
              id='fieldEmail'
              maxLength='200'
              name='cm-urtlhyd-urtlhyd'
              required=''
              placeholder='Enter your email'
              type='email'
            />
            {/* </div>
          <div className='relative flex items-start'>
            <div className='flex h-5 items-center'>
              <input className='h-4 w-4 rounded border-stone-300' aria-required={true} id='cm-privacy-consent' name='cm-privacy-consent' required='' type='checkbox' />
            </div>
            <label htmlFor='cm-privacy-consent' className='ml-3 text-sm font-medium'>
              I agree to be emailed - We care about the protection of your data. Read our{' '}
              <a href='/privacy-policy' className='font-medium text-white underline'>
                Privacy Policy.
              </a>
            </label>
          </div> */}
            <button
              className='bg-white text-brand-orange inline-block transform whitespace-nowrap px-5 py-2 shadow-inner transition duration-300 font-bold ease-in-out hover:border-white rounded-l-none rounded-r-sm'
              type='submit'
              name='subscribe'
              id='subscribe'>
              Send
            </button>
          </div>
        </form>
        <Script id='create-send' strategy='idle' src='https://js.createsend1.com/javascript/copypastesubscribeformlogic.js' />
      </div>
    </div>
  )
}
export default Newsletter
